import { atom } from 'jotai';

const isZipCodeFromUserServiceableAtom = atom(true);

export default isZipCodeFromUserServiceableAtom;
